<template>
    <div id="main">
        <transition name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        is_layout_data_fetched: Boolean
    },
    data: function () {
        return {
            is_loading: false
        }
    },
    created: function() {
        var that = this;

        that.set_breadcrumbs();
        that.init();
    },
    mounted: function() {
        var that = this;
    },
    watch: {
        is_layout_data_fetched: function(value) {
            var that = this;

            if (value) {
                that.init();
            }
        },
    },
    methods: {
        init: function() {
            var that = this;

        },
        set_breadcrumbs: function() {
            var that = this;

            var index = {
                route_name: 'settings',
                name: '設定區'
            };

            switch (that.$route.name) {
                case 'settings':
                    that.$store.state.breadcrumbs = [index];
                    break;
                default:
            }
        },
    },
}
</script>
